import script from "./subscription-item-editable.vue?vue&type=script&setup=true&lang=ts"
export * from "./subscription-item-editable.vue?vue&type=script&setup=true&lang=ts"

import "./subscription-item-editable.vue?vue&type=style&index=0&id=974f0be0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-974f0be0"]])

export default __exports__